// AUTH ACTION TYPES
export const ADMIN_LOGIN_INIT = "ADMIN_LOGIN_INIT";
export const ADMIN_LOGIN_SUCCESS = "ADMIN_LOGIN_SUCCESS";
export const ADMIN_LOGIN_FAIL = "ADMIN_LOGIN_FAIL";

//GET ADMIN PROFILE
export const GET_ADMIN_PROFILE_INIT = "GET_ADMIN_PROFILE_INIT";
export const GET_ADMIN_PROFILE_SUCCESS = "GET_ADMIN_PROFILE_SUCCESS";
export const GET_ADMIN_PROFILE_FAIL = "GET_ADMIN_PROFILE_FAIL";

//GET ALL USERS
export const GET_ALL_USER_INIT = "GET_ALL_USER_INIT";
export const GET_ALL_USER_SUCCESS = "GET_ALL_USER_SUCCESS";
export const GET_ALL_USER_FAIL = "GET_ALL_USER_FAIL";
 
//GET EXPERT USERS
export const GET_EXPERT_USER_INIT = "GET_EXPERT_USER_INIT";
export const GET_EXPERT_USER_SUCCESS = "GET_EXPERT_USER_SUCCESS";
export const GET_EXPERT_USER_FAIL = "GET_EXPERT_USER_FAIL";

//DELETE USERS ACCOUNT
export const DELETE_USER_INIT = "DELETE_USER_INIT";
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const DELETE_USER_FAIL = "DELETE_USER_FAIL";

//GET RECYCLE DATA
export const GET_RECYCLE_INIT = "GET_RECYCLE_INIT";
export const GET_RECYCLE_SUCCESS = "GET_RECYCLE_SUCCESS";
export const GET_RECYCLE_FAIL = "GET_RECYCLE_FAIL";

//RESTORE USER ACCOUNT  
export const RESTORE_USER_ACCOUNT_INIT = "RESTORE_USER_ACCOUNT_INIT";
export const RESTORE_USER_ACCOUNT_SUCCESS = "RESTORE_USER_ACCOUNT_SUCCESS";
export const RESTORE_USER_ACCOUNT_FAIL = "RESTORE_USER_ACCOUNT_FAIL";

//GET USERS FEEDBACK
export const GET_USERS_FEEDBACK_INIT = "GET_USERS_FEEDBACK_INIT";
export const GET_USERS_FEEDBACK_SUCCESS = "GET_USERS_FEEDBACK_SUCCESS";
export const GET_USERS_FEEDBACK_FAIL = "GET_USERS_FEEDBACK_FAIL";

//USER_FEEDBACKS ACCOUNT
export const USER_FEEDBACK_INIT = "USER_FEEDBACK_INIT";
export const USER_FEEDBACK_SUCCESS = "USER_FEEDBACK_SUCCESS";
export const USER_FEEDBACK_FAIL = "USER_FEEDBACK_FAIL";

// WITHDRAWAL REQUESTS LIST
export const WITHDRAWAL_REQUESTS_LIST_INIT = "WITHDRAWAL_REQUESTS_LIST_INIT";
export const WITHDRAWAL_REQUESTS_LIST_SUCCESS = "WITHDRAWAL_REQUESTS_LIST_SUCCESS";
export const WITHDRAWAL_REQUESTS_LIST_FAIL = "WITHDRAWAL_REQUESTS_LIST_FAIL";

// CHNAGE REQUEST STATUS
export const CHANGE_REQUEST_STATUS_INIT = "CHANGE_REQUEST_STATUS_INIT";
export const CHANGE_REQUEST_STATUS_SUCCESS = "CHANGE_REQUEST_STATUS_SUCCESS";
export const CHANGE_REQUEST_STATUS_FAIL = "CHANGE_REQUEST_STATUS_FAIL";

// REPORTS LIST
export const REPORTS_LIST_INIT = "REPORTS_LIST_INIT";
export const REPORTS_LIST_SUCCESS = "REPORTS_LIST_SUCCESS";
export const REPORTS_LIST_FAIL = "REPORTS_LIST_FAIL";

//GET_CALL_HISTORY_INIT
export const GET_CALL_HISTORY_INIT = "GET_CALL_HISTORY_INIT";
export const GET_CALL_HISTORY_SUCCESS = "GET_CALL_HISTORY_SUCCESS";
export const GET_CALL_HISTORY_FAIL = "GET_CALL_HISTORY_FAIL";

//PAYMENT 
export const PAYMENT_DETAILS_INIT = "PAYMENT_DETAILS_INIT";
export const PAYMENT_DETAILS_SUCCESS = "PAYMENT_DETAILS_SUCCESS";
export const PAYMENT_DETAILS_FAIL = "PAYMENT_DETAILS_FAIL";